export enum AdministrationPageTypes {
  Partner = 'PARTNER',
  User = 'USER',
  Address = 'ADDRESS',
  Plant = 'PLANT',
}
